export const SECTION_DESIGN = 'design';
export const SECTION_THEME = 'theme';
export const SECTION_SETTINGS = 'settings';
export const SECTION_SHARE = 'share';
export const SECTION_TEAM = 'team';
export const SECTION_RESULTS = 'results';
export const SECTION_RESPONSES = 'responses';
export const SECTION_WIDGET = 'widget';

